module.exports = __webpack_public_path__ + "static/media/amazonLogoLight.55a400d2.png";